export default function toSidebarItem(entry, ctx) {
    const badge = entry.badge?.(ctx);
    return {
        prefix: entry.prefix,
        label: entry.label(ctx),
        to: entry.to,
        renderIcon: entry.renderIcon,
        ...(badge ? { badge } : {}),
    };
}
